// Local, bundled logo — avoids intermittent failures loading a remote asset on mobile networks.
export const LOGO_URL = "/logo.png";
